import axios from 'axios';
import { getRedirectionUrlFromAPI, unsetAuthToken } from './utils';
import { navigateToLogin } from './router';
import { CHANNEL_ID, TOKEN } from '../constants/common';
import GTM from '../GTM';
import API from '.';
import { getCookie, getDomain } from '../utils/common';

const initAxios = () => {
  axios.interceptors.response.use(
    (response: any) => {
      if (response.config.responseType === 'arraybuffer' && response.headers['content-type'] === 'application/pdf') {
        return Promise.resolve(response);
      } else if (response.headers['content-type'] === 'text/html; charset=UTF-8') {
        // this.navigateToErrorPage();
        return Promise.resolve(response);
      } else {
        const data = response.data;
        const statusType = data.status.statusType;
        if (statusType === 'SUCCESS') {
          return Promise.resolve(response);
        }
        if (statusType === 'ERROR') {
          // When any error from API call comes then record a GTM event with passing status code of the error
          GTM.error.onErrorPageLoad(data.status.statusCode);
          const newError = processError(data, response.config.url);
          return Promise.reject(newError);
        }
        return Promise.resolve();
      }
    },
    (error: Error) => {
      // this.navigateToErrorPage();
      return Promise.reject(error);
    }
  );
};

function processError(error: any, apiUrl: string): { errorCode: number; errorMsg: Error } {
  let errorCode: number = error.status.statusCode;
  let errorMsg: Error = new Error(error.status.statusMessage);
  let errorResponse = { errorCode, errorMsg };
  switch (errorCode) {
    case 4001:
    case 4002:
      document.cookie = `${TOKEN}=;expires=${new Date().toString()};domain=${getDomain()}`;
      // navigateToLogin(getRedirectionUrlFromAPI(apiUrl));
      unsetAuthToken();
      navigateToLogin(getCookie(CHANNEL_ID));
      break;
    case 9000:
      sessionStorage.clear();

    default:
      break;
  }
  return errorResponse;
}

export { initAxios };
